import React from 'react';
import { Link } from 'react-router-dom';
import config from '../../../config/config';
const playlistUnsupportedAPIs = ['pandora', 'soundcloud', 'amazon'];

class PlaylistImage extends React.Component {
	render (){
		const { playlist } = this.props;
		
		return <Link to={`/playlists/${playlist.id}/details`}><div className="logo-container" >
			<div className="logo" style={{backgroundImage: `url(${playlist.logo})`}} />
			<img src={`${config.apis.playlist}/playlists/${playlist.id}/active`} width={0} height={0} />
			{(playlist.dummyImage && !playlistUnsupportedAPIs.includes(playlist.vendor)) && <img src={`${config.apis.playlist}/playlists/${playlist.id}/collect_metadata/${playlist.vendor}`} width={0} height={0} />}
		</div></Link>;

	}
}

export default PlaylistImage;